module.exports = __webpack_public_path__ + "static/media/elk_slough_path.fd1e9f27.svg";